const key = "assessment";
const baseRoute = "/eoemanagement/endofemployment";

export const Const = {

  professionalAttribute: {
    lngKey: `${key}.professionalAttribute`,
    route: ``,
  },
  evaluationScale: {
    lngKey: `${key}.evaluationScale`,
    route: ``,
  },
  probation: {
    lngKey: `${key}.probation`,
    route: ``,
  },
  evaluation: {
    lngKey: `${key}.evaluation`,
    route: ``,
  },


};

const cmn = "common";
export const Commons = {
  create: `${cmn}.create`,
  update: `${cmn}.update`,
  view: `${cmn}.view`,
  name: `${cmn}.name`,
  code: `${cmn}.code`,
  location: `${cmn}.location`,
  branch: `${cmn}.branch`,
  department: `${cmn}.department`,
  designation: `${cmn}.designation`,
  joiningDate: `${cmn}.joiningDate`,
  grade: `${cmn}.grade`,
  ProfileCompletion: `${cmn}.ProfileCompletion`,
  actions: `${cmn}.actions`,
  is_active: `${cmn}.is_active`,
  status: `${cmn}.status`,
  description: `${cmn}.description`,
  shortname: `${cmn}.shortname`,
  country: `${cmn}.country`,
  employee: `${cmn}.employee`,

};
export const colors = {
  "bg-warning": "#faad14",
  "bg-warning-color": "black",
  "bg-success": "green",
  "bg-success-color": "white"
}


